module.exports = __webpack_public_path__ + "img/delete.51505cc3.svg";